import React, { useState } from "react";
import { useNavigate } from "react-router";

import { useAppRouteParams } from "../../../../../AppRoutes";
import { postRemoveVersion } from "../../../../../api/version";
import { Version } from "../../../../../domain/Version";
import { DialogPhaseStatesType, useDialog } from "../../../helpers/hooks";
import { getDialogMessages } from "../../helper";

export const DialogVersionRemoveSome: React.FC<
  {
    versions: Version[];
    selectedVersionIds: string[];
    setSelectedVersionIds: React.Dispatch<React.SetStateAction<string[]>>;
  } & DialogPhaseStatesType
> = ({
  versions,
  selectedVersionIds,
  setSelectedVersionIds,
  dialogPhase,
  setDialogPhase,
}) => {
  const { organizationId, versionId: nowVersionId } = useAppRouteParams();
  const navigate = useNavigate();

  const selectedVersions = versions.filter(({ id }) =>
    selectedVersionIds.includes(id)
  );

  const { renderDialogs, setIsInProgress, showErrorAPIDialog } = useDialog({
    dialogPhase,
    setDialogPhase,
  });
  const progressTotal = selectedVersionIds.length;
  const [progressCount, setProgressCount] = useState(0);

  const runRemove = async () => {
    if (selectedVersions.length > 0) {
      setProgressCount(0);
      try {
        if (selectedVersionIds.includes(nowVersionId)) {
          navigate(`/organizations/${organizationId}`);
        }
        setDialogPhase("in_progress");
        for (const versionId of selectedVersionIds) {
          await postRemoveVersion({
            organizationId,
            versionId,
          });
          setProgressCount((cnt) => cnt + 1);
          // APIの実行時の制限に従い、1秒待機
          // ref: [レートリミット: どの1秒間(ウィンドウ)を見ても、ある呼び出しユーザによるAPI実行は最大で1つしか存在しないこと。](https://www.notion.so/algo-artis/SSUI-API-2025-05-13ver-184af951024b807897a6cf64f1f2fb91?pvs=4#184af951024b806692d8f529eebbc756)
          // そのため、APIの実行時に1秒待機することで、レートリミットを回避する。
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
        setSelectedVersionIds([]);
        setDialogPhase("success");
      } catch (error) {
        showErrorAPIDialog(error);
      }
    }
  };
  const messages = getDialogMessages({
    isSome: true,
    actionType: "remove",
    targetType: "version",
  });

  return (
    <>
      {renderDialogs({
        confirm: {
          onClick: runRemove,
          onClickCancel: () => {
            setSelectedVersionIds([]);
          },
          isThemeRed: true,
          ...messages.confirm,
        },
        inProgress: {
          ...messages.inProgress,
          count: {
            current: progressCount,
            total: progressTotal,
          },
        },
        success: {
          ...messages.success,
        },
        errorAPI: { ...messages.error },
      })}
    </>
  );
};
